import { render, staticRenderFns } from "./Anxunheader.vue?vue&type=template&id=117894d8&scoped=true"
import script from "./Anxunheader.vue?vue&type=script&lang=js"
export * from "./Anxunheader.vue?vue&type=script&lang=js"
import style0 from "./Anxunheader.vue?vue&type=style&index=0&id=117894d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117894d8",
  null
  
)

export default component.exports